import React from 'react';
import { useLanguage } from '../../../context/LanguageContext';
import logo from '../../../logo-full.svg';
import './Footer.css';

const Footer = ({ scrollToSection }) => {
  const { t } = useLanguage();

  return (
    <footer className="bg-gray-900 text-gray-300 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div>
            <div className="mb-4">
              <img src={logo} alt="First Capital Global Cambodia" className="h-14 w-auto logo-inverted" />
            </div>
            <p className="text-gray-400">
              {t('footer.tagline')}
            </p>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">{t('footer.quickLinks')}</h4>
            <div className="space-y-2">
              {['about', 'services', 'values', 'contact'].map((link) => (
                <button
                  key={link}
                  onClick={() => scrollToSection(link)}
                  className="block text-gray-400 hover:text-brand-light transition-colors capitalize"
                >
                  {t(`nav.${link}`)}
                </button>
              ))}
            </div>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">{t('footer.officeHours')}</h4>
            <p className="text-gray-400 mb-2">{t('footer.mondayFriday')}</p>
            <p className="text-white font-semibold">{t('footer.mondayFridayTime')}</p>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-8 text-center text-gray-400">
          <p>&copy; {t('footer.copyright')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
